var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_706",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00083 11.9997C1.00083 5.92477 5.92552 1.00009 12.0004 1.00009C18.0753 1.00009 23 5.92477 23 11.9997C23 18.0746 18.0753 22.9993 12.0004 22.9993C10.3445 22.9993 8.74039 22.6323 7.28073 21.9379L6.94428 21.7701L2.13979 22.9719C1.50206 23.1313 0.921376 22.5905 1.00875 21.9605L1.02819 21.8604L2.2282 17.054C1.48353 15.6163 1.06353 14.0279 1.00733 12.3808L1.00083 11.9997ZM21.1667 12.0004C21.1667 6.938 17.0628 2.8341 12.0004 2.8341C6.93796 2.8341 2.83406 6.938 2.83406 12.0004C2.83406 13.5941 3.24049 15.1266 4.00358 16.4843C4.11827 16.6884 4.15055 16.9286 4.09379 17.1557L3.17688 20.823L6.84443 19.9067C7.03372 19.8594 7.23211 19.8739 7.41109 19.9465L7.51593 19.9969C8.87377 20.7602 10.4065 21.1667 12.0004 21.1667C17.0628 21.1667 21.1667 17.0628 21.1667 12.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41736 14.7491C6.91112 14.7491 6.50073 14.3387 6.50073 13.8325C6.50073 13.3624 6.85459 12.975 7.31047 12.922L7.41736 12.9159H12.9172C13.4234 12.9159 13.8338 13.3263 13.8338 13.8325C13.8338 14.3026 13.4799 14.69 13.0241 14.743L12.9172 14.7491H7.41736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41736 11.0831C6.91112 11.0831 6.50073 10.6728 6.50073 10.1665C6.50073 9.69643 6.85459 9.30899 7.31047 9.25604L7.41736 9.24988L16.5837 9.24988C17.0899 9.24988 17.5003 9.66027 17.5003 10.1665C17.5003 10.6366 17.1465 11.024 16.6906 11.077L16.5837 11.0831H7.41736Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech_bubble.26ff62620b72467634045b9d7fe95d84.svg";
export { ForwardRef as ReactComponent };